import { render, staticRenderFns } from "./AssigneeDialog.vue?vue&type=template&id=6536b861&"
import script from "./AssigneeDialog.vue?vue&type=script&lang=js&"
export * from "./AssigneeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports